import { fetchYouTubePlaylistTracks } from "../utils/fetchYouTubePlaylistTracks";
import { fetchSpotifyPlaylistTracks } from "../utils/fetchSpotifyPlaylistTracks";

export const usePreparePlaylists = () => {
  const enhancePlaylistsWithTracks = async (playlists, platform) => {
    const withTracks = await Promise.all(
      playlists?.map(async (playlist) => {
        let tracks = [];
        if (platform === 'youtube') {
          tracks = await fetchYouTubePlaylistTracks(playlist.id);
        } else if (platform === 'spotify') {
          tracks = await fetchSpotifyPlaylistTracks(playlist.id);
        }
        return {
          ...playlist,
          tracks,
          duration: tracks.reduce((sum, t) => sum + (t.duration || 0), 0),
        };
      })
    );
    return withTracks;
  };

  return { enhancePlaylistsWithTracks };
};
